<template>
  <div class="mod-production-order">
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="工单号"><el-input v-model="q.productionOrderCode" size="small" clearable style="width:150px" /></el-form-item>
      <el-form-item label="产品编码"><el-input v-model="q.materialCode" size="small" clearable style="width:150px" /></el-form-item>
      <el-form-item label="销售单号"><el-input v-model="q.salesOrderCode" size="small" clearable style="width:150px" /></el-form-item>
      <el-form-item label="状态">
        <el-select v-model="q.orderStatus" clearable size="small" style="width:120px">
          <el-option label="草稿" value="0" /><el-option label="已下达" value="1" /><el-option label="已完工" value="3" /><el-option label="已关闭" value="4" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('production:productionOrder:list')" type="primary" size="small" @click="search">查询</el-button>
        <el-button v-if="isAuth('production:productionOrder:save')" type="primary" size="small" @click="open()">新增</el-button>
        <el-button v-if="isAuth('production:productionOrder:fromSales')" type="primary" size="small" @click="mergePushHandle">订单合并下推</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" border v-loading="loading" :header-cell-style="headStyle" @row-dblclick="rowDblclick">
      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="productionOrderCode" label="工单号" min-width="140" header-align="center" align="left">
        <template slot-scope="scope">
          <a v-if="isAuth('production:productionOrder:info')" class="code-link" @click="open(scope.row.productionOrderId, true)">{{ scope.row.productionOrderCode }}</a>
          <span v-else>{{ scope.row.productionOrderCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="materialCode" label="产品编码" min-width="120" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="materialName" label="产品名称" min-width="140" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="productionOrderDate" label="业务日期" width="110" header-align="center" align="left">
        <template slot-scope="scope">{{ (scope.row.productionOrderDate || '').slice(0, 10) }}</template>
      </el-table-column>
      <el-table-column prop="planStartDate" label="计划开工" width="110" header-align="center" align="left">
        <template slot-scope="scope">{{ (scope.row.planStartDate || '').slice(0, 10) || '—' }}</template>
      </el-table-column>
      <el-table-column prop="planFinishDate" label="计划完工" width="110" header-align="center" align="left">
        <template slot-scope="scope">
          <span :style="scope.row.scheduleOverdue === '1' ? 'color:#f56c6c' : ''">{{ (scope.row.planFinishDate || '').slice(0, 10) || '—' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="quantity" label="计划数量" width="100" header-align="center" align="left" />
      <el-table-column prop="receivedQty" label="已入库" width="100" header-align="center" align="left">
        <template slot-scope="scope">{{ formatOrderQty(scope.row.receivedQty) }}</template>
      </el-table-column>
      <el-table-column prop="mergeMode" label="下推方式" width="90" header-align="center" align="left">
        <template slot-scope="scope">{{ scope.row.mergeMode === 'merge' ? '合并' : (scope.row.mergeMode === 'single' ? '不合并' : '—') }}</template>
      </el-table-column>
      <el-table-column prop="salesOrderSummary" label="销售订单" min-width="120" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="reportProcessRate" label="工序完成率" width="110" header-align="center" align="left">
        <template slot-scope="scope">{{ Number(scope.row.reportProcessRate || 0).toFixed(2) }}%</template>
      </el-table-column>
      <el-table-column prop="lastProcessStatus" label="末道工序" width="90" header-align="center" align="center" />
      <el-table-column prop="orderStatus" label="状态" width="90" header-align="center" align="center" fixed="right">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.orderStatus === '1'" type="primary" size="small">已下达</el-tag>
          <el-tag v-else-if="scope.row.orderStatus === '3'" type="success" size="small">已完工</el-tag>
          <el-tag v-else-if="scope.row.orderStatus === '4'" type="info" size="small">已关闭</el-tag>
          <el-tag v-else type="warning" size="small">草稿</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="settleStatus" label="结算" width="80" header-align="center" align="center" fixed="right">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.settleStatus === '2'" type="success" size="small">已结</el-tag>
          <el-tag v-else-if="scope.row.orderStatus !== '0'" type="info" size="small">未结</el-tag>
          <span v-else>—</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[20, 50, 100]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="s => { pageSize = s; pageIndex = 1; load() }" @current-change="p => { pageIndex = p; load() }" />

    <production-order-add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="load" />
    <production-push-merge-from-sales v-if="mergePushVisible" ref="mergePush" @success="load" />
  </div>
</template>

<script>
import { listProductionOrder } from '../../api/production/productionOrder'
import { fetchPerms } from '../../api/auth'
import { checkAuth } from '../../utils/isAuth'
import ProductionOrderAddOrUpdate from './productionOrder-add-or-update.vue'
import ProductionPushMergeFromSales from './production-push-merge-from-sales.vue'

export default {
  name: 'ProductionOrder',
  components: { ProductionOrderAddOrUpdate, ProductionPushMergeFromSales },
  data() {
    return {
      q: { productionOrderCode: '', materialCode: '', salesOrderCode: '', orderStatus: '' },
      list: [], pageIndex: 1, pageSize: 20, total: 0, loading: false, hasActivated: false, permCodes: [],
      addOrUpdateVisible: false, mergePushVisible: false,
      headStyle: { background: '#f5f7fa', color: '#606266' }
    }
  },
  created() { this.loadPerms(); this.load().then(() => this.openFromQuery()) },
  activated() {
    if (this.hasActivated) this.load()
    else this.hasActivated = true
  },
  watch: { '$route.query.viewId'() { this.openFromQuery() } },
  methods: {
    isAuth(perm) { return checkAuth(this.$store.state.user, this.permCodes, perm) },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    formatOrderQty(val) {
      if (val == null || val === '') return '0'
      const n = Number(val)
      if (Number.isNaN(n)) return '0'
      return n.toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
    },
    search() { this.pageIndex = 1; this.load() },
    load() {
      this.loading = true
      return listProductionOrder({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        productionOrderCode: this.q.productionOrderCode,
        materialCode: this.q.materialCode,
        salesOrderCode: this.q.salesOrderCode,
        orderStatus: this.q.orderStatus
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).catch(() => { this.list = []; this.total = 0 }).finally(() => { this.loading = false })
    },
    rowDblclick(row) {
      if (!row || !row.productionOrderId || !this.isAuth('production:productionOrder:info')) return
      this.open(row.productionOrderId, true)
    },
    openFromQuery() {
      const id = this.$route.query.viewId
      if (!id) return
      this.open(id, true)
    },
    open(id, readonly) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => this.$refs.addOrUpdate && this.$refs.addOrUpdate.init(id || null, !!readonly))
    },
    mergePushHandle() {
      this.mergePushVisible = true
      this.$nextTick(() => this.$refs.mergePush && this.$refs.mergePush.init({}))
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.code-link { color: #348adb; cursor: pointer; }
.code-link:hover { text-decoration: underline; }
</style>
